import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { TouchableHighlight, View, Dimensions } from "react-native";
import Text from "../../components_v2/TextFont";
import * as CONSTS from "../../../assets/consts";

import { ScenarioDeviceEventCondition } from "../../viewModels/Scenario";
import IntervalPicker from "../../components_v2/IntervalPicker";
import { translate } from "../../locales/translate";
import Theme from "../../argon-ui/Theme";
const { width } = Dimensions.get("screen");
/**
 * @augments {Component<props, state>}
 */
class MainConditionDevice extends Component {
  static propTypes = {
    onPress: PropTypes.func,
    model: PropTypes.object,
  };

  constructor(props) {
    super(props);
    let { model } = this.props;

    var _model = new ScenarioDeviceEventCondition(
      CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE
    );
    Object.assign(_model, model);

    this.state = {
      model: _model,
    };
    this.allIntervalTypes = ["second", "minute"];
  }

  componentDidMount() {}
  handleOnPress = () => {
    this.props.onPress && this.props.onPress(this.state.model.tempId);
  };
  render() {
    return (
      <TouchableHighlight underlayColor="#e2e2e2" onPress={this.handleOnPress}>
        <View style={this.props.style || {}}>
          <Text
            style={{
              marginBottom: 10,
              paddingVertical: 10,
              paddingBottom: 20,
              borderBottomColor: Theme.COLORS.BORDER,
              borderBottomWidth: 1,
            }}
          >
            {/* {translate(`scenario.${this.state.model.eventName}`)}{" "}
            {deviceType ? translate(`deviceGroup.${deviceType}`) : ""}{" "}
            {deviceName ? this.state.model.deviceName  : ""} */}
            {this.state.model.getSummary()}
          </Text>

          {/* === ignore event interval === */}
          <IntervalPicker
            label={translate("scenario.ignoreEventsInterval")}
            helpText={translate("scenario.ignoreEventsIntervalInfo", {
              ignoreEventsInterval:
                this.props.ignoreEventsIntervalValue +
                " " +
                translate(`timer.${this.props.ignoreEventsIntervalType}`),
            })}
            data={this.allIntervalTypes}
            valueInput={this.props.ignoreEventsIntervalValue}
            valueSelect={this.props.ignoreEventsIntervalType}
            onChangeText={(value) => {
              typeof this.props.onChangeIgnoreEventsIntervalValue ===
                "function" &&
                this.props.onChangeIgnoreEventsIntervalValue(value);
            }}
            onChangeSelect={(value, index, data) => {
              typeof this.props.onChangeIgnoreEventsIntervalType ===
                "function" &&
                this.props.onChangeIgnoreEventsIntervalType(value);
            }}
          />
        </View>
      </TouchableHighlight>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    deviceReducer: state.DeviceReducer,
  };
};

export default connect(mapStateToProps)(MainConditionDevice);
